import { childInventoryType } from '../shared/purchase-order-state';
import {purchaseOrderTraders} from '../shared/purchase-order-traders';
import { PurchaseOrderLookupsService } from '../shared/purchase-order-lookups.service';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { lastValueFrom } from 'rxjs';

import { PDFDocument } from 'pdf-lib';
import { PurchaseOrderFormComponent } from '../purchase-order-form/purchase-order-form.component';
import { RmsModule } from '@rms';
import { WebService, PopupService, ReportService, RmsMessageService } from '@services';
import { PurchaseOrder, Inventory, Column, TableIcon } from '@interfaces';
import { environment } from '../../../../../../environments/environment'

@Component({
  selector: 'app-spread-purchase-order-form',
  imports: [RmsModule],
  templateUrl: './spread-purchase-order-form.component.html',
  styleUrl: './spread-purchase-order-form.component.scss'
})
export class SpreadPurchaseOrderFormComponent implements OnInit{
  @Input() PurchaseOrderSpread: string | undefined;

  @Output() ReturnToList = new EventEmitter<boolean>;
  @Output() onUpdateSpread = new EventEmitter<string>;
  @Output() onViewSpread = new EventEmitter<any[]>();
  @Output() onViewPurchaseOrder = new EventEmitter<any>();

  PurchaseOrders: PurchaseOrder[] = [];
  PurchaseOrder: PurchaseOrder | undefined;
  TablePurchaseOrder: any[] = [];
  PurchaseOrderColumns: Column[] = [];
  PurchaseOrderColumnsNew: Column[] = [];
  ChildInventoryColumns: Column[] = []
  PurchaseOrderColumnIcons: TableIcon[] = []
  InventoryData: any | undefined;
  InventoryName: string = '';
  DecafInventoryName: string = '';
  Updated: boolean = false;
  saving = false;
  loading = true;
  loadError = '';

  AllTariffed: boolean = false;
  DecafInventoryNames: string[] = [];

  private env: string = this.getEnvironment(environment.WS_URL);
  constructor(private lookups: PurchaseOrderLookupsService, private web: WebService, private popup: PopupService, private report: ReportService, private sanitizer: DomSanitizer, private message: RmsMessageService) { }

  async ngOnInit() {
    this.loading = true;
    this.loadError = '';
    try {
    if (this.PurchaseOrderSpread) {
      this.PurchaseOrders = await lastValueFrom(this.web.getWebCall('inventory', 'coffee/purchase-order/', {
        params: [{ name: 'PurchaseOrderSpread', value: this.PurchaseOrderSpread }]
      }));
      if (!this.PurchaseOrders.length) throw new Error('Spread not found.');
      this.InventoryData = await this.GetInventoryData();
      console.log(this.PurchaseOrders);
      for (const po of this.PurchaseOrders) {
        const match = this.InventoryData.Traders.find((u:any)=>String(u.GraphUserID).toLowerCase()===String(po.TraderGUID).toLowerCase());
        if (match) po.TraderGUID=match.GraphUserID;
      }
      this.InventoryData.AllFuturesMonths = this.InventoryData.FuturesMonths;
      this.InventoryData.FuturesMonths = this.InventoryData.FuturesMonths.filter((fm: any) => fm.Exchange == this.PurchaseOrders![0].Inventory![0].FuturesExchangeKey);
      

      // Build it from all POs (case-insensitive de-dupe, keep original casing)
      const seen = new Set<string>();
      const names: string[] = [];

      for (const po of this.PurchaseOrders ?? []) {
        for (const inv of po?.Inventory ?? []) {
          const raw = inv?.InventoryTypeName;
          if (!inv?.DecaffeinatorID || typeof raw !== 'string') continue;

          const key = raw.trim().toLowerCase();
          if (key && !seen.has(key)) {
            seen.add(key);
            names.push(raw.trim()); // keep first-seen casing
          }
        }
      }

      this.DecafInventoryNames = names;

      // Optional: if you still need a single display string
      this.DecafInventoryName = names.join(', ');      this.PurchaseOrder = this.PurchaseOrders[0];
      this.InventoryName = this.PurchaseOrders![0].Inventory![0].InventoryTypeName;
      this.CreateSpreadData();
    }
    } catch (error) { this.loadError = 'Unable to load the spread. Please retry.'; }
    finally { this.loading = false; }
  }
  CreateSpreadData() {
    this.TablePurchaseOrder = []; // reset to avoid duplicates on reruns
    this.AllTariffed = this.PurchaseOrders.every(po => po.TariffInPrice);

    // Helper: shape child inventory like CreateInventoryColumns -> toDisplay
    const toChildDisplay = (inv: any, parent: any, futuresName: string) => {
      const buyingTerm = parent.BuyingTermID;
      const priceHeader = buyingTerm == 1 ? 'Cost' : 'Differential';
      const priceLabel = buyingTerm == 1
        ? (parent.PricePerUnit ?? inv.PricePerUnit ?? '')
        : `${futuresName}${(parent.DifferentialPerUnit ?? 0) >= 0 ? '+' : ''}${parent.DifferentialPerUnit ?? ''}`;

      return {
        ...inv,
        ChildType: childInventoryType(inv, parent),
        InventoryID: inv.InventoryID,
        SupplierReffNumber: inv.SupplierReffNumber,
        InventoryTypeName: inv.InventoryTypeName,
        BagsOrdered: inv.BagsOrdered,
        NetWeight: inv.NetWeight,
        FOBtoExWarehouseValueTemp: inv.FOBtoExWarehouseValueTemp,
        ExWhseCost: inv.ExWhseCost,
        BuyingTermID: buyingTerm,
        PriceHeader: priceHeader,
        PriceLabel: priceLabel,
        ShippingHeader:
          inv.ShipmentTypeID == 1 && inv.ShippingTerm != 4 ? 'FOBtoExWarehouse ($\\lb.)' : 'ExWarehouse ($\\lb.)',
        ShippingLabel:
          inv.ShipmentTypeID == 1 && inv.ShippingTerm != 4 ? inv.FOBtoExWarehouseValueTemp : inv.ExWhseCost,
        LandedHeader:
          buyingTerm == 1 ? 'Estimated Landed Cost ($\\lb.)' : 'Estimated Landed Diff ($\\lb.)',
        LandedLabel:
          buyingTerm == 1 ? inv.FinalWarehouseInCost : inv.FinalWarehouseInDifferential,

        WarehouseLabel: this.InventoryData?.DestinationWarehouses?.find((dw: any) => dw.LocationID == inv.FinalDestinationWarehouseID)?.LocationName ?? '',
      }
    };

    for (const pur of this.PurchaseOrders) {
      const inventory: any[] = pur.Inventory ?? [];
      const parents = inventory.filter((i:any)=>!i.ParentInventoryID || !inventory.some((p:any)=>Number(p.InventoryID)===Number(i.ParentInventoryID)));
      for (const inv0 of parents) {
      const futuresName =
        this.InventoryData?.FuturesMonths?.find((fm: any) => fm.FutureCompositeID == inv0.FutureCompositeID)?.FutureCompositeName ?? '';

      const destinationName =
        this.InventoryData?.DestinationWarehouses?.find((dw: any) => dw.LocationID == inv0.FinalDestinationWarehouseID)?.LocationName ?? '';

      // Build children = ONLY decaf inventory lines under this PO
      const childInvsRaw: any[] = [...(inv0.ChildInventory ?? []), ...inventory.filter((i:any)=>Number(i.ParentInventoryID)===Number(inv0.InventoryID))];
      const childInvs = childInvsRaw.map(ci => toChildDisplay(ci, inv0, futuresName));

      const hasDecaf = childInvs.some((i:any)=>Number(i.DecaffeinatorID)>0);

      // Parent row (UNCHANGED fields from your original), plus new ChildInventory/expand flags
      const parentRow = {
        PurchaseOrderID: pur.PurchaseOrderID,
        InventoryID: inv0.InventoryID,
        ShipLabel: this.formatMonthYearCode(inv0.ETDMonth, inv0.ETDYear),
        DestinationWarehouse: destinationName,
        BagsOrdered: inv0.BagsOrdered,
        PricePoundLabel: inv0.PricePerUnit,
        DifferentialPerPoundLabel: futuresName + (inv0.DifferentialPerUnit >= 0 ? '+' : '') + inv0.DifferentialPerUnit,
        FOBtoExWarehouseValueTemp: inv0.FOBtoExWarehouseValueTemp,
        FinalWarehouseInCost: inv0.FinalWarehouseInCost,
        FinalWarehouseInDifferential: inv0.FinalWarehouseInDifferential,
        BuyingTermID: inv0.BuyingTermID,
        SupplierReffNumber: inv0.SupplierReffNumber,
        Notes: inv0.Notes,
        WebInvisible: inv0.WebInvisible,
        FutureCompositeID: inv0.FutureCompositeID,
        TariffInPrice: pur.TariffInPrice,
        ExWhseCost: inv0.ExWhseCost,
        ShipmentType: inv0.ShipmentType,
        ShipmentTypeID: inv0.ShipmentTypeID,
        PriceDescriptor: inv0.PriceDescriptorName,
        HasDecaf: hasDecaf,
        // 🔹 New: highlight + children + expand flags
        //rowHighlight: hasDecaf ? {
        //  text: 'DECAF',
        //  textColor: 'green',
        //  // you can add background: 'rgba(0,148,216,0.08)' if you want a tint
        //  //margin: '200px',
        //  columnKey: 'DestinationWarehouse'
        //} : null,
        DecafLabel: hasDecaf ? 'DCF' : '',
        ChildInventory: childInvs,          // 👈 used by your expanded template
        expandable: childInvs.length > 0,               // 👈 tells the table there’s an expanded section
        expanded: childInvs.length > 0,                 // 👈 open by default when decaf exists (works with your table logic)
        NetWeight: inv0.NetWeight,
        InventoryTypeName: inv0.InventoryTypeName
        // expandText: hasDecaf ? { hide: 'Child', show: 'Child' } : null
      };

      this.TablePurchaseOrder.push(parentRow);
      }
    }

    // Parent columns: keep exactly your original logic
    this.PurchaseOrderColumns = [
      { label: 'PO #', key: 'PurchaseOrderID', width: 5 },
      { label: 'REf #', key: 'InventoryID', width: 5 },
      {
        label: "Supplier Ref#", type: 'text', key: 'SupplierReffNumber', edit: true,
        onAction: (row: any) => {
          this.PurchaseOrders.find((po: any) => po.PurchaseOrderID == row.PurchaseOrderID)!.Inventory!.find((i:any)=>Number(i.InventoryID)===Number(row.InventoryID))!.SupplierReffNumber = row.SupplierReffNumber;
          this.Updated = true;
        }, width: 5
      },
      { label: 'Product', key: 'InventoryTypeName', width: 10 },
      { label: '', key: 'DecafLabel', width: 5, columnClass: 'cell-decaf', removeSort: true },
      { label: 'Ship Date', key: 'ShipLabel', width: 5 },
      { label: 'Destination', key: 'DestinationWarehouse', width: 5 },
      { label: 'Bags', key: 'BagsOrdered', width: 5 },
      { label: 'Net Wt.', key: 'NetWeight', width: 5 },
      {
        label: (this.TablePurchaseOrder[0]?.BuyingTermID == 2 ? 'Diff ' : 'Price ') + (this.TablePurchaseOrder[0]?.PriceDescriptor ?? ''),
        key: this.TablePurchaseOrder[0]?.BuyingTermID == 2 ? 'DifferentialPerPoundLabel' : 'PricePoundLabel',
        type: this.TablePurchaseOrder[0]?.BuyingTermID == 2 ? 'text' : 'currency', width:5
      },
      {
        label: this.TablePurchaseOrder[0]?.ShipmentTypeID == 1 ? 'FobToExWarehouse' : 'ExWharehouse',
        key: this.TablePurchaseOrder[0]?.ShipmentTypeID == 1 ? 'FOBtoExWarehouseValueTemp' : 'ExWhseCost',
        type: 'currency',
        format: '1.4-4', width:10
      },
      {
        label: 'Estimated Landed Per Pound',
        key: this.TablePurchaseOrder[0]?.BuyingTermID == 2 ? 'FinalWarehouseInDifferential' : 'FinalWarehouseInCost',
        type: 'currency',
        format: '1.4-4', width:10
      },
      {
        label: "Notes", type: 'textarea', key: 'Notes', edit: true,
        onAction: (row: any) => {
          this.PurchaseOrders.find((po: any) => po.PurchaseOrderID == row.PurchaseOrderID)!.Inventory!.find((i:any)=>Number(i.InventoryID)===Number(row.InventoryID))!.Notes = row.Notes;
          this.Updated = true;
        }, width: 5
      },
      {
        label: "Web Invisible", type: 'checkbox', key: 'WebInvisible', edit: true,
        onAction: (row: any) => {
          this.PurchaseOrders.find((po: any) => po.PurchaseOrderID == row.PurchaseOrderID)!.Inventory!.find((i:any)=>Number(i.InventoryID)===Number(row.InventoryID))!.WebInvisible = row.WebInvisible;
          this.Updated = true;
        }, width: 5
      },
      {
        label: "Tariff Included", type: 'checkbox', key: 'TariffInPrice', edit: true,
        onAction: (row: any) => {
          this.PurchaseOrders.find((po: any) => po.PurchaseOrderID == row.PurchaseOrderID)!.TariffInPrice = row.TariffInPrice;
          this.Updated = true;
        }, width: 5
      }
    ];

    this.PurchaseOrderColumnIcons = [
      { action: (row: any) => this.ViewPurchaseOrder(row), icon: 'edit', title: 'Edit Single Purchase Order.' },
      { action: (row: any) => this.onViewConfirm(row), icon: 'assignment', title: 'View Purchase Order Confirm.' },
    ];

    // 🔹 Child columns: SAME as your CreateInventoryColumns ChildInventoryColumns
    this.ChildInventoryColumns = [
      { label: 'Type', key: 'ChildType', width: 12 },
      { label: 'Ref #', key: 'InventoryID', width: 10, align: 'center' },
      { label: 'Product', key: 'InventoryTypeName', width: 20, align: 'center' },
      { label: 'Destination Warheouse', key: 'WarehouseLabel', width: 20, align: 'center' },
      { label: 'Bags', key: 'BagsOrdered', width: 10, align: 'center' },
      { label: 'Net Wt', key: 'NetWeight', width: 10, type: 'number', fixed: 4, align: 'center' },
      { labelKey: 'PriceHeader', key: 'PriceLabel', width: 10, align: 'center' },
      { labelKey: 'ShippingHeader', key: 'ShippingLabel', width: 10, type: 'currency', format: '1.4-4', align: 'center' },
      { labelKey: 'LandedHeader', key: 'LandedLabel', width: 10, type: 'currency', format: '1.4-4', align: 'center' },
    ];
  }
  UpdateTariffInPrice() {
    setTimeout(() => {
      this.PurchaseOrders.forEach((po: any) => {
        po.TariffInPrice = this.AllTariffed;
      })
      this.TablePurchaseOrder.forEach((t: any) => {
        t.TariffInPrice = this.AllTariffed;
      })
      this.Updated = true;
    }, 100)
  }
  ViewPurchaseOrder(row: any) {
    if (this.saving || (this.Updated && !confirm('Discard unsaved spread changes?'))) return;
    //this.popup.open({
    //  component: PurchaseOrderFormComponent,
    //  data: { PurchaseOrder: this.PurchaseOrders.find((po: any) => po.PurchaseOrderID == row.PurchaseOrderID) }
    //})
    console.log(row);
    this.onViewPurchaseOrder.emit(this.PurchaseOrders.find((po: any) => po.PurchaseOrderID == row.PurchaseOrderID));
  }
  async onViewConfirm(row: any) {
    const PurchaseOrder = this.PurchaseOrders.find((po: any) => po.PurchaseOrderID == row.PurchaseOrderID)
    let blob = await lastValueFrom(this.report.getReport('NewPurchaseOrderReport', [{ name: 'purchaseOrderID', value: PurchaseOrder!.PurchaseOrderID }, { name: "envir", value: this.env }], 'pdf'));
    const url = URL.createObjectURL(blob);
    this.popup.open({
      title: 'Purchase Order Confirm',
      reportUrl: this.sanitizer.bypassSecurityTrustResourceUrl(url),
      startingHeight: "800px"
    });
  }
  async OpenSpreadConfirm() {
    const mergedPdf = await PDFDocument.create();

    // Step 1: Run all report requests concurrently
    const reportPromises = this.PurchaseOrders.map(po =>
      lastValueFrom(this.report.getReport(
        'NewPurchaseOrderReport',
        [
          { name: 'purchaseOrderID', value: po.PurchaseOrderID },
          { name: 'envir', value: this.env }
        ],
        'pdf'
      ))
    );

    // Step 2: Wait for all PDF blobs to return
    const pdfBlobs = await Promise.all(reportPromises);

    // Step 3: Merge all PDFs into one
    for (const blob of pdfBlobs) {
      const pdfBytes = await blob.arrayBuffer();
      const pdf = await PDFDocument.load(pdfBytes);
      const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
      copiedPages.forEach(page => mergedPdf.addPage(page));
    }

    // Step 4: Generate and open the merged PDF
    const mergedPdfBytes = await mergedPdf.save();
    const mergedBlob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
    const url = URL.createObjectURL(mergedBlob);

    this.popup.open({
      title: 'Purchase Order Confirm',
      reportUrl: this.sanitizer.bypassSecurityTrustResourceUrl(url),
      startingHeight: '800px'
    });
  }

  private async GetInventoryData() {
    const products$ = this.lookups.get('inventory', 'coffee/products');
    const paymentTerms$ = this.lookups.get('data', 'coffee/payment-terms');
    const sampleApprovalTerms$ = this.lookups.get('data', 'coffee/sample-approval-terms');
    const weightTypes$ = this.lookups.get('data', 'coffee/weight-types');
    const shipmentTerms$ = this.lookups.get('data', 'coffee/shipment-terms');
    const shipmentTypes$ = this.lookups.get('data', 'coffee/shipment-types');
    const futuresMonths$ = this.lookups.get('inventory', 'coffee/risk-board/futures');
    const destinationWarehouses$ = this.lookups.get('data', 'coffee/locations');
    const destinationPorts$ = this.lookups.get('data', 'coffee/destinations');
    const priceDescriptors$ = this.lookups.get('data', 'coffee/price-descriptors');
    const originRates$ = this.lookups.get('data', 'coffee/origin-rates');
    const costings$ = this.lookups.get('data', 'coffee/costings');
    const decaffeinators$ = this.lookups.get('data', 'coffee/decaffeinators');
    const traders$ = this.lookups.get('users', 'users');
    const suppliers$ = this.lookups.get('inventory', 'coffee/suppliers');

    const [
      Products,
      PaymentTerms,
      SampleApprovalTerms,
      WeightTypes,
      ShipmentTerms,
      ShipmentTypes,
      FuturesMonths,
      DestinationWarehouses,
      DestinationPorts,
      PriceDescriptors,
      OriginRates,
      Costings,
      Decaffeinators,
      Traders,
      Suppliers
    ] = await Promise.all([
      lastValueFrom(products$),
      lastValueFrom(paymentTerms$),
      lastValueFrom(sampleApprovalTerms$),
      lastValueFrom(weightTypes$),
      lastValueFrom(shipmentTerms$),
      lastValueFrom(shipmentTypes$),
      lastValueFrom(futuresMonths$),
      lastValueFrom(destinationWarehouses$),
      lastValueFrom(destinationPorts$),
      lastValueFrom(priceDescriptors$),
      lastValueFrom(originRates$),
      lastValueFrom(costings$),
      lastValueFrom(decaffeinators$),
      lastValueFrom(traders$),
      lastValueFrom(suppliers$),
    ]);

    return {
      AllFuturesMonths: FuturesMonths,
      Products,
      PaymentTerms,
      SampleApprovalTerms,
      WeightTypes,
      ShipmentTerms,
      ShipmentTypes,
      FuturesMonths,
      DestinationWarehouses,
      DestinationPorts,
      PriceDescriptors,
      OriginRates,
      Costings,
      Decaffeinators,
      Traders: purchaseOrderTraders(Traders, this.PurchaseOrders[0]?.TraderGUID),
      Suppliers,
    };
  }
  FinalizeUser(): boolean {
    const origin = this.PurchaseOrder?.Inventory![0].Origin;
    if (!origin) return false;

    const groups = JSON.parse(localStorage.getItem("userGroups") || "[]");

    // Check if user has a group like "Coffee-[Origin]"
    const requiredGroup = `Coffee-${origin}`;
    return groups.includes(requiredGroup);
  }
  formatMonthYearCode(month: number, year: number): string {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  // Normalize month (1–12)
  if (!month || month < 1 || month > 12 || !year) return '';

  // Normalize year to 2-digit string
  const yearStr = (year % 100).toString().padStart(2, '0');

  return `${monthNames[month - 1]}'${yearStr}`;
  }
  onBackToList() {
    if (this.saving || (this.Updated && !confirm('Discard unsaved spread changes?'))) return;
    this.ReturnToList.emit(false);
  }
  onNewSpread() {
    if (this.saving || (this.Updated && !confirm('Discard unsaved spread changes?'))) return;
    this.ReturnToList.emit(true);
  }
  async UpdateSpread() {
    if (this.saving) return;
    this.saving = true;
    try {
      const result = await lastValueFrom(this.web.getWebCall('inventory', 'coffee/purchase-order/save-spread', {
        body: { orders: this.PurchaseOrders, existingIds: this.PurchaseOrders.map(po => po.PurchaseOrderID) }
      }));
      this.Updated = false;
      this.onUpdateSpread.emit(result.PurchaseOrderSpread);
    } catch (error: any) {
      this.message.error(error?.error?.error ?? 'Unable to save the spread. Your edits are still available.');
    } finally { this.saving = false; }
  }
  ViewSpread() {
    if (this.saving || (this.Updated && !confirm('Discard unsaved spread changes?'))) return;
    this.onViewSpread.emit(this.PurchaseOrders);
  }
  ArrayHasDecaf(): boolean {
    return this.PurchaseOrders?.some((po: any) =>
      po.Inventory?.some((i: any) => !!i.DecaffeinatorID)
    ) ?? false;
  }
  private getEnvironment(envUrl: string): string {
    switch (envUrl) {
      case 'http://localhost:5150': return 'DEV';
      case 'https://dev-exp.royalny.net': return 'WEB-DEV';
      case 'https://qa-exp.royalny.net': return 'WEB-QA';
      default: return 'PROD';
    }
  }
}
